
import { defineComponent, PropType } from "vue";
import { SelectedCtaModel } from "../clients/search/src/models";

export default defineComponent({
  props: {
    selectedFilter: {
      type: Object as PropType<SelectedCtaModel>,
      required: true,
      default: undefined
    },
    selectedFilters: {
      type: Array as PropType<SelectedCtaModel[]>,
      required: true,
      default: () => []
    }
  },
  setup(props, context) {
    const clickFilters = (tagId) => {
      context.emit("preSelectedFilterClick", tagId, props.selectedFilters);
    };

    return {
      clickFilters
    };
  }
});
